import Swiper from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-shop-colour-carousel]',
};

class ShopColourCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);
      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      breakpoints: {
        640: {
          spaceBetween: 20,
        },
        744: {
          spaceBetween: 28,
        },
        1024: {
          spaceBetween: 28,
        },
        1665: {
          spaceBetween: 30,
        }
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.carousel.update();
    });
  }
}

customElements.define('shop-colour-carousel', ShopColourCarousel);
